import NewsletterSection from '@/components/NewsletterSection'
import BlogCard from '@/components/BlogCard'
import BlueHero from '@/components/BlueHero'
import { getMission, getLatestBlogs } from '@/lib/api'

export default async function AboutMission() {
  const [data, blogs] = await Promise.all([getMission(), getLatestBlogs()])
  const latestBlogs = blogs?.slice(0, 3) || []

  const fallbackCards = [
    {
      id: 1,
      title: 'Mentorship And Guidance',
      contents: [
        { id: 1, content: 'Providing Tailored Mentorship To Emerging Entrepreneurs.' },
        { id: 2, content: 'Offering Strategic Guidance Utilizing Our Vast Experience Across Various Industries.' },
        { id: 3, content: 'Helping Entrepreneurs Navigate Challenges And Capitalize On Opportunities.' },
      ],
    },
    {
      id: 2,
      title: 'Investment And Support',
      contents: [
        { id: 1, content: 'Investing In Promising Startups And Disruptive Technologies.' },
        { id: 2, content: 'Providing Critical Capital And Expertise To Fuel The Success Of Innovative Ideas.' },
        { id: 3, content: 'Supporting Startups In Achieving Sustainable Growth And Long-Term Success.' },
      ],
    },
    {
      id: 3,
      title: 'Legacy Of Impact',
      contents: [
        { id: 1, content: 'Investing In Promising Startups And Disruptive Technologies.' },
        { id: 2, content: 'Providing Critical Capital And Expertise To Fuel The Success Of Innovative Ideas.' },
        { id: 3, content: 'Supporting Startups In Achieving Sustainable Growth And Long-Term Success.' },
      ],
    },
  ]

  const cards = (data?.core_values && data.core_values.length > 0 ? data.core_values : fallbackCards) as any[]

  return (
    <>
      <BlueHero title="MR. ALRIFAI MISSION" />

      {/* MISSION CONTENT */}
      <section style={{ background: '#07090e', padding: '64px 0 72px' }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '0 40px' }}>
          <h2
            style={{
              fontSize: 'clamp(20px, 3vw, 26px)',
              fontWeight: 900,
              color: '#fff',
              textAlign: 'center',
              letterSpacing: '0.04em',
              lineHeight: 1.4,
              marginBottom: '20px',
            }}
          >
            GUIDING SUCCESS THROUGH EXPERTISE AND INVESTMENT
          </h2>
          <p
            style={{
              fontSize: '13.5px',
              color: 'rgba(255,255,255,0.60)',
              lineHeight: 1.95,
              textAlign: 'center',
              maxWidth: '820px',
              margin: '0 auto 48px',
            }}
          >
            {data?.mission?.description ||
              "Ghassan's Mission Is Clear: He Supports Aspiring Entrepreneurs From His Extensive Experience Across Diverse Industries. He Also Invests In Promising Startups And Disruptive Technologies, Providing Essential Capital And Expertise To Fuel Their Success And Contribute To A Thriving Future. Ultimately, He Wants To Leave A Legacy Of Positive Impact, Empowering Entrepreneurs And Nurturing A Culture Of Innovation And Progress."}
          </p>

          <div className="mission-cols">
            {cards.map((card) => (
              <div
                key={card.id}
                style={{
                  border: '1px solid rgba(249,115,22,0.55)',
                  borderRadius: '8px',
                  padding: '24px 22px',
                  background: 'rgba(0,0,0,0.25)',
                }}
              >
                <h3
                  style={{
                    fontSize: '15px',
                    fontWeight: 800,
                    color: '#f97316',
                    marginBottom: '18px',
                  }}
                >
                  {card.title}
                </h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  {(card.contents || []).map((c: any) => (
                    <div key={c.id} style={{ display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
                      <span style={{ color: '#f97316', fontWeight: 900, fontSize: '13px', flexShrink: 0, lineHeight: 1.6 }}>//</span>
                      <p style={{ fontSize: '12.5px', color: 'rgba(255,255,255,0.66)', lineHeight: 1.7 }}>{c.content}</p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FROM HIS BLOG */}
      <section className="relative overflow-hidden" style={{ background: '#161920', padding: '64px 0' }}>
        <div className="absolute inset-0 pointer-events-none" style={{ backgroundImage: 'url(/arab-pattern-bg.jpg)', backgroundSize: 'cover', opacity: 0.07, zIndex: 0 }} />
        <div className="absolute inset-0 pointer-events-none" style={{ background: 'rgba(16,18,26,0.80)', zIndex: 0 }} />
        <div className="relative z-10" style={{ maxWidth: '1000px', margin: '0 auto', padding: '0 32px' }}>
          <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#fff', textAlign: 'center', marginBottom: '10px' }}>From His Blog</h2>
          <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.48)', textAlign: 'center', lineHeight: 1.85, maxWidth: '520px', margin: '0 auto 40px' }}>
            Dive Into The Blog For The Latest Updates, Expert Opinions, And Detailed Information On Our Projects. Stay Updated With Content Relevant To You.
          </p>
          <div className="resp-grid-3">
            {(latestBlogs.length > 0 ? latestBlogs : [
              { id: '1', title: 'Fly High With Our Exclusive Travel Tips', image: '/story-event.jpg', date: '24.08.2024', category: 'Travel', likes: 23, comments: 5 },
              { id: '2', title: 'Fly High With Our Exclusive Travel Tips', image: '/story-event.jpg', date: '24.08.2024', category: 'Travel', likes: 23, comments: 5 },
              { id: '3', title: 'Fly High With Our Exclusive Travel Tips', image: '/story-event.jpg', date: '24.08.2024', category: 'Travel', likes: 23, comments: 5 },
            ]).map((p: any) => (
              <BlogCard key={p.id} id={String(p.id)} title={p.title} image={p.image} date={p.created_at || p.date} category={p.category || ''} likes={p.likes_count ?? p.likes ?? 0} comments={p.comments_count ?? p.comments ?? 0} />
            ))}
          </div>
        </div>
      </section>

      <NewsletterSection />

      <style>{`
        .mission-cols { display: grid; grid-template-columns: repeat(3, 1fr); gap: 18px; }
        @media (max-width: 860px) { .mission-cols { grid-template-columns: 1fr; } }
      `}</style>
    </>
  )
}
